import { FLYBITS } from '../constants';
import { IApp, IProject } from '../types/app';
import axios from '../utils/axios';

export const getProjects = async (session: string): Promise<IProject[]> => {
    const endpoint = FLYBITS.PROXY_HOST + '/kernel/projects?min=20&max=1000000&limit=1000000';
    const response = (await axios.get(endpoint, {
        headers: {
            'Authorization': session
        }
    }));
    let projects = [];
    if (200 === response.status) {
        projects = response.data.data;
    } 
    return projects;
}


export const loadApp = (): IApp => ({
    drawerOpen: true,
    projects: [],
})



// WEBPACK FOOTER //
// ./src/services/app.ts